import {
	Backdrop,
	Box,
	Card,
	Chip,
	CircularProgress,
	Divider,
	Typography,
	useMediaQuery,
	Checkbox,
	Button,
	FormControl,
	MenuItem,
	Select,
	InputLabel,
	OutlinedInput,
} from '@mui/material'
import React, { Fragment, useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { DOMAIN } from '../../utils/api'
import axios from 'axios'
import { handleError } from '../../utils/error'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { billDetailActions, currentUserActions } from '../../redux/store'
import { getFromStorage } from '../../utils/storage'
import { mainBlue, mainGreen, mainRed } from '../../utils/color'

export default function ImportStockBillByStore() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const mediaMd = useMediaQuery('(min-width:768px)')
	const token = getFromStorage('current-user')?.accessToken
	const [loadingSearch, setLoadingSearch] = useState(true)
	const [currentImage, setCurrentImage] = useState(null)
	const [isViewerOpen, setIsViewerOpen] = useState(false)
	const [products, setProducts] = useState([])
	const [productsFilter, setProductsFilter] = useState([])
	const [store, setStore] = useState()
	const [orderFilter, setOrderFilter] = useState('')
	const { storeId } = useParams()

	const openImageViewer = (photo) => {
		setCurrentImage(photo)
		setIsViewerOpen(true)
	}

	const closeImageViewer = () => {
		setCurrentImage(null)
		setIsViewerOpen(false)
	}

	const getProducts = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/stock/bill/${storeId}`,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setProducts(
					response.data.data.map((item) => ({
						...item,
						checked: item?.payment === 'unbill' ? false : true,
					})),
				)
				setProductsFilter(
					response.data.data.map((item) => ({
						...item,
						checked: item?.payment === 'unbill' ? false : true,
					})),
				)
				setStore(response.data.store)
				setLoadingSearch(false)
			} catch (err) {
				handleError(err)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[dispatch, navigate, token, storeId],
	)

	useEffect(() => {
		getProducts()
	}, [getProducts])

	const handleChangeOrder = (e) => {
		setOrderFilter(e.target.value)
	}

	useEffect(() => {
		if (orderFilter === 'unbill') {
			const unbillOrder = productsFilter.filter((item) => item.payment === 'unbill')
			setProducts(unbillOrder)
		} else if (orderFilter === 'billed') {
			const billedOrder = productsFilter.filter((item) => item.payment === 'billed')
			setProducts(billedOrder)
		} else if (orderFilter === 'paid') {
			const paidOrder = productsFilter.filter((item) => item.payment === 'paid')
			setProducts(paidOrder)
		} else {
			setProducts(productsFilter)
		}
	}, [orderFilter, productsFilter])

	const handleChangeCheck = (e) => {
		let { value, checked } = e.target
		const findIndex = products.findIndex((item) => item._id === value)
		if (findIndex !== -1) {
			const updateProduct = [...products]
			updateProduct[findIndex].checked = checked
			setProducts(updateProduct)
		}
	}

	const cancelBill = async (orderId) => {
		try {
			await axios({
				url: `${DOMAIN}/stock/cancel-bill/${orderId}`,
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			getProducts()
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<UserLayout>
			{loadingSearch ? (
				<Box display='flex' justifyContent='center' sx={{ marginTop: '120px' }}>
					<CircularProgress sx={{ color: mainGreen }} />
				</Box>
			) : (
				<Card
					sx={{
						padding: '20px 20px 10px 20px',
						background: '#fff',
					}}>
					<Backdrop
						sx={{
							color: '#fff',
							zIndex: 999,
							left: mediaMd ? 300 : 0,
						}}
						open={isViewerOpen}
						onClick={closeImageViewer}>
						<img
							loading='lazy'
							src={currentImage}
							alt='attach'
							style={{
								maxHeight: '70%',
								maxWidth: '90%',
							}}
							onClick={(e) => {
								e.stopPropagation()
							}}
						/>
					</Backdrop>
					<Typography
						sx={{
							fontWeight: 'bold',
							textAlign: 'center',
							letterSpacing: '2px',
							mb: 2,
						}}>
						ĐƠN THANH TOÁN {store?.name}
					</Typography>
					<Box display='flex' alignItems='center' justifyContent='center' sx={{ mb: 2 }}>
						<FormControl sx={{ minWidth: 110 }} size='small'>
							<InputLabel id='select-label'>Lọc đơn</InputLabel>
							<Select
								id='order-select'
								name='order'
								value={orderFilter}
								labelId='select-label'
								input={<OutlinedInput label='Lọc đơn' />}
								onChange={handleChangeOrder}>
								<MenuItem value=''>
									<em>- Tất cả -</em>
								</MenuItem>
								<MenuItem value='unbill'>Chưa thanh toán</MenuItem>
								<MenuItem value='billed'>Chờ xác nhận</MenuItem>
								<MenuItem value='paid'>Đã thanh toán</MenuItem>
							</Select>
						</FormControl>
					</Box>
					<Button
						sx={{
							color: mainRed,
							borderColor: mainRed,
							'&:hover': {
								borderColor: mainRed,
							},
							mb: 1,
						}}
						size='small'
						onClick={() => {
							navigate(`/admin/bill-list/${storeId}`)
						}}
						variant='outlined'>
						Hóa đơn đã xuất
					</Button>
					{orderFilter !== 'billed' && orderFilter !== 'paid' && (
						<Box display='flex' justifyContent='space-between' alignItems='center' sx={{ mb: 2 }}>
							<Typography sx={{ fontWeight: 'bold', mr: 2 }}>
								Đã chọn: {products?.filter((item) => item.payment === 'unbill' && item.checked)?.length} đơn
							</Typography>
							<Button
								sx={{
									background: mainGreen,
									'&:hover': { background: mainGreen },
								}}
								variant='contained'
								size='small'
								onClick={() => {
									const payload = products.filter((item) => item.payment === 'unbill' && item.checked)
									if (payload.length === 0) {
										alert('Chưa có đợt nhập hàng nào được chọn')
										return
									}
									dispatch(billDetailActions.getBillDetail({ detail: payload, store }))
									navigate(`/admin/bill-review/${storeId}`)
								}}>
								Xem hóa đơn
							</Button>
						</Box>
					)}

					{products?.map((prod, index) => {
						return (
							<Fragment key={index}>
								{prod.action === 'export' && prod.request.status === 'complete' && (
									<>
										{prod?.payment === 'unbill' && (
											<Chip
												sx={{
													marginBottom: -1,
													color: '#fff',
													background: mainRed,
												}}
												size='small'
												label='Chưa thanh toán'
											/>
										)}
										<Box display='flex' alignItems='flex-end' sx={{ mb: 1 }}>
											{prod?.payment === 'billed' && (
												<Chip
													sx={{
														color: '#fff',
														background: mainBlue,
														mr: 1,
													}}
													size='small'
													label='Chờ xác nhận'
												/>
											)}
											{prod?.payment === 'paid' && (
												<Chip
													sx={{
														color: '#fff',
														background: mainGreen,
														mr: 1,
													}}
													size='small'
													label='Đã thanh toán'
												/>
											)}
											{prod?.billCode && (
												<Typography sx={{ fontSize: '14px', fontWeight: 'bold', mr: 1 }}>
													Mã: {prod?.billCode}
												</Typography>
											)}
											{prod?.paymentPicture?.map((image, index) => {
												return (
													<img
														loading='lazy'
														key={index}
														src={image}
														onClick={(e) => {
															openImageViewer(image)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)
											})}
										</Box>

										<Box display='flex' justifyContent='space-between' alignItems='center'>
											<Typography>
												<span style={{ color: mainGreen, fontWeight: 'bold' }}>(+{prod.request?.quantity})</span> nhập
												từ <b>{prod.user?.name}</b>.{' '}
												{(prod?.unitPrice || prod?.unitPrice === 0) && (
													<span>
														Đơn giá{' '}
														<span style={{ color: mainGreen, fontWeight: 'bold' }}>
															{prod?.unitPrice.toLocaleString()}
														</span>
														đ.
													</span>
												)}{' '}
												{(prod?.unitPrice || prod?.unitPrice === 0) && (
													<span>
														Tổng tiền{' '}
														<span style={{ color: mainRed, fontWeight: 'bold' }}>
															{(Math.round(prod.quantity * 0.98) * prod?.unitPrice).toLocaleString()}
														</span>
														đ.
													</span>
												)}{' '}
												{prod.note && <span style={{ fontStyle: 'italic' }}>({prod.note}).</span>}{' '}
												<span>
													Tồn: <b>{Number(prod.balanceStore)?.toFixed(1)}</b>
													kg
												</span>
											</Typography>
											{prod?.payment === 'unbill' && (
												<Checkbox
													color='success'
													value={prod._id}
													checked={prod.checked}
													onChange={handleChangeCheck}
												/>
											)}
										</Box>
										<Box display='flex' alignItems='flex-end' sx={{ mb: 1 }}>
											<Typography
												sx={{
													fontStyle: 'italic',
													fontSize: '12px',
													textAlign: 'right',
													marginTop: '3px',
													mr: 1,
												}}>
												- {prod.timeStamp} -
											</Typography>
											{prod.request.confirmPicture && (
												<img
													loading='lazy'
													src={prod.request.confirmPicture}
													onClick={(e) => {
														openImageViewer(prod.request.confirmPicture)
													}}
													width='30'
													height='30'
													style={{
														marginRight: '8px',
														marginTop: '2px',
														cursor: 'pointer',
													}}
													alt=''
												/>
											)}
											{prod?.deliveryReceiptPicture?.map((image, index) => {
												return (
													<img
														loading='lazy'
														key={index}
														src={image}
														onClick={(e) => {
															openImageViewer(image)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)
											})}
											{prod.request?.confirmMultiPicture?.map((image, index) => {
												return (
													<img
														loading='lazy'
														key={index}
														src={image}
														onClick={(e) => {
															openImageViewer(image)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)
											})}
										</Box>
										{prod?.payment === 'billed' && (
											<Button
												size='small'
												sx={{ color: mainRed }}
												onClick={() => {
													const confirmCancel = window.confirm('Hủy thanh toán đơn?')
													if (confirmCancel) {
														cancelBill(prod._id)
													}
												}}>
												Hủy thanh toán
											</Button>
										)}
										<Divider sx={{ mb: 2 }} />
									</>
								)}
							</Fragment>
						)
					})}
				</Card>
			)}
		</UserLayout>
	)
}
